import { render, staticRenderFns } from "./childInsuranceSchool.vue?vue&type=template&id=4b30167d&scoped=true&"
import script from "./childInsuranceSchool.vue?vue&type=script&lang=js&"
export * from "./childInsuranceSchool.vue?vue&type=script&lang=js&"
import style0 from "./childInsuranceSchool.vue?vue&type=style&index=0&id=4b30167d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b30167d",
  null
  
)

export default component.exports